import React from "react";
import { Button, Container, Divider, Grid, Skeleton } from "@mui/material";

const CoursesAvailablesSkeleton = () => {
  return (
    <Container
      fixed
      sx={{
        paddingTop: 5,
      }}
    >
      <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={4}>
          <Skeleton variant="rectangular" height={800} />
        </Grid>
        <Grid item xs={4}>
          <Skeleton variant="rectangular" height={800} />
        </Grid>
        <Grid item xs={4}>
          <Skeleton variant="rectangular" height={800} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default CoursesAvailablesSkeleton;
